import { useMutation, useQueryClient } from '@tanstack/react-query';
import { assessmentService } from '@services';
import { showToast } from '@utils/toast';

/**
 * Cancels an assessment and refreshes every list and detail view that shows it.
 * Errors are left to the caller: the reason dialog shows them inline, the plain
 * confirmation shows a toast.
 */
export const useCancelAssessment = (assessmentId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (reason?: string) => assessmentService.cancelAssessment(assessmentId, reason),
    onSuccess: async () => {
      await Promise.all([
        // Detail pages key the assessment by the route param, which is a string
        queryClient.invalidateQueries({ queryKey: ['assessment', String(assessmentId)] }),
        queryClient.invalidateQueries({ queryKey: ['assessments'] }),
        queryClient.invalidateQueries({ queryKey: ['assessments-table'] }),
        queryClient.invalidateQueries({ queryKey: ['assessments-counts'] }),
        queryClient.invalidateQueries({ queryKey: ['supplier-assessments'] }),
        queryClient.invalidateQueries({ queryKey: ['contract-assessments'] })
      ]);
      showToast.success('Assessment cancelled successfully');
    }
  });
};
